import {
    CLIENT_PREMIUM_LOAD_ERROR,
    CLIENT_PREMIUM_LOAD_SUCCESS,
    CLIENT_PRODUCTS_LOAD_ERROR,
    CLIENT_PRODUCTS_LOAD_REQUEST,
    CLIENT_PRODUCTS_LOAD_SUCCESS,
    CLIENT_TIMESTAMP,
} from '../actions/client'
import moment from 'moment'

export const initialState = {
    premium: null,
    premium_plus: null,
    premium_vip: null,
    hasPremium: false,
    products: {},
    errorMessage: null,
    loading: false,
    loaded: false,
}

// eslint-disable-next-line complexity
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case CLIENT_PRODUCTS_LOAD_REQUEST: {
        return {
            ...state,
            loading: true,
            loaded: false,
            errorMessage: null,
        }
    }
    case CLIENT_PRODUCTS_LOAD_SUCCESS: {
        return {
            ...state,
            products: action.payload,
            loading: false,
            loaded: true,
        }
    }
    case CLIENT_TIMESTAMP: {
        const serverTime = moment.unix(action.payload)
        const deltaTime = serverTime.diff(moment(), 'ms')
        return {
            ...state,
            deltaTime,
        }
    }
    case CLIENT_PRODUCTS_LOAD_ERROR: {
        return {
            ...state,
            loading: false,
            loaded: false,
            errorMessage: action.payload.errorMessage,
        }
    }
    case CLIENT_PREMIUM_LOAD_SUCCESS: {
        const { premium, premium_plus, premium_vip } = action.payload
        return {
            ...state,
            premium,
            premium_plus,
            premium_vip,
            hasPremium: premium.active || premium_plus.active,
        }
    }
    case CLIENT_PREMIUM_LOAD_ERROR: {
        return {
            ...state,
            premium: null,
            premium_plus: null,
            premium_vip: null,
            hasPremium: false,
            errorMessage: action.payload.errorMessage,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/client.js